const BookingStatusEnum = {
  UNDEFINED: 0,
  WAITING: 1,
  CONFIRMED: 2,
  RESERVED: 3,
  DEPOSIT: 4,
  PAID: 5,
  CANCELLED: 6,
  PENDING: 7,
  ONBOARD: 8,
  EXPIRED: 9,
  CHECKOUT: 10,
  CHECKINCOMMINGSOON: 11,
  CHECKOUTCOMMINGSOON: 12,
  BOOKING_EXPIRED: 13
}
export default BookingStatusEnum



// WEBPACK FOOTER //
// ./src/enum/bookingStatusEnum.js